import { render } from "./PreparationTime.vue?vue&type=template&id=ecac1040&scoped=true"
import script from "./PreparationTime.vue?vue&type=script&lang=js"
export * from "./PreparationTime.vue?vue&type=script&lang=js"

import "./PreparationTime.vue?vue&type=style&index=0&id=ecac1040&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecac1040"]])

export default __exports__